import { AuthContextType } from "context/auth-context";
import React, { useEffect } from "react";
export type reqDataType = {
  panelListId: string | number;
  type: number | number;
};
type GroupButtonType = { id: number; name: string };
export const ButtonGroup = ({
  reqData,
  setReqData,
  userAuthenticationData,
  setCurrentPage,
  allButtons,
}: {
  reqData: reqDataType;
  setReqData: React.Dispatch<React.SetStateAction<reqDataType>>;
  userAuthenticationData: AuthContextType;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  allButtons: GroupButtonType[];
}) => {
  function handleTabChange(value: number) {
    // Mirrors the previous radio group: re-selecting the active tab is a no-op.
    if (value === reqData.type) return;
    //handle tab change
    setReqData({
      panelListId: userAuthenticationData.auth.panelistId,
      type: value,
    });
    setCurrentPage(1);
  }

  useEffect(() => {
    console.log(reqData.type);
  }, [reqData.type]);

  return (
    <div className="w-full overflow-x-auto zs-scroll sm:w-auto">
      <div className="flex min-w-max zs-segmented sm:min-w-0" role="tablist" aria-label="Study status">
        {allButtons.map((button) => (
          <button
            key={button.id}
            type="button"
            role="tab"
            value={button.id}
            aria-selected={button.id === reqData.type}
            onClick={() => handleTabChange(button.id)}
            className="flex-1 whitespace-nowrap sm:flex-none sm:px-4"
          >
            {button.name}
          </button>
        ))}
      </div>
    </div>
  );
};
